<template >
<div class="container-fluid" v-if="lesson">
   
   <div class="row">
     <div class="col-md-8 col-sm-12">

    
      <div class="card mb-4"   v-if="lesson.groups && lesson.groups.length>0">
        <div class="card-header py-3">
          <div class="row">
            <div class="col">
              <h3 class="m-0 font-weight-bold text-primary">Хичээлийн үзүүлэлт</h3>
            </div>

          </div>
        </div>
        <div class="card-body" >
          <div>
            <table class="table table-bordered table-sm">
              <thead>
                <tr>

                  <th>Бүлэг</th>
                  <th>Сурагч</th>
                  
                  <th v-for="(topic) in topics">
                    {{topic.name}}
                    <div v-if="topic">
                      <div>
                        Ойлгосон: {{topic.numberOfUnderstand}}, 
                        Ойлгоогүй: {{topic.numberOfNotUnderstand}}
                      </div>
                      
                      <div  class="row">
                        <div class="col" v-if="topic.procent">
                          <div class="progress">
                            <div class="progress-bar bg-info" role="progressbar" v-bind:style="'width: '+topic.procent+'%'" aria-valuemin="0" aria-valuemax="100">{{topic.procent}} %</div>
                          </div>
                        </div>
                        <div class="col" v-else>
                          <div class="progress">
                            <div class="progress-bar bg-danger" role="progressbar" v-bind:style="'width: '+0+'%'" aria-valuemin="0" aria-valuemax="100">0 %</div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </th>
                </tr>
              </thead>

              <tbody v-for="(group, gindex) in groups">
                <tr v-for="(student, sindex) in group.students">
                  <td v-if="sindex==0" v-bind:rowspan="group.students.length">{{gindex+1}}.
                    <span v-if="group.isGroup && group.isGroup==true">{{group.groupName}}</span>
                    <span v-else> {{group.departmentName}}/{{group.programName}}</span>
                  </td>
                  <td>{{student.name}}</td>
                  <td v-for="usertdoc in student.topics">
                    <div v-if="usertdoc && usertdoc.data">
                      <div>
                        Ойлгосон: {{usertdoc.data.numberOfUnderstand}}, 
                        Ойлгоогүй: {{usertdoc.data.numberOfNotUnderstand}}
                      </div>
                      
                      <div  class="row">
                        <div class="col" v-if="usertdoc.procent">
                          <div class="progress">
                            <div class="progress-bar bg-info" role="progressbar" v-bind:style="'width: '+usertdoc.procent+'%'" aria-valuemin="0" aria-valuemax="100">{{usertdoc.procent}} %</div>
                          </div>
                        </div>
                        <div class="col" v-else>
                          <div class="progress">
                            <div class="progress-bar bg-danger" role="progressbar" v-bind:style="'width: '+0+'%'" aria-valuemin="0" aria-valuemax="100">0 %</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      -
                    </div>
                  </td>
          
                </tr>
              </tbody>
   
            </table>
          </div>
        </div>
      </div>



      <div v-else class="alert alert-warning text-center mb-4"><h4>Та одоогоор ямар нэгэн сэдэв оруулаагүй байна.</h4></div>
      <hr class="mb-5"/>
      
   

     </div>
     <div class="col-md-4 col-sm-12">
        <lesson-info :lesson="lesson" :schoolId="schoolId" :edit="false" :showDetail="false"></lesson-info>
     </div>
   </div>
</div>
    
</template>

<script>
const fb = require('../../../firebaseConfig.js')
import { mapState } from 'vuex'
import moment from 'moment'
import firebase from 'firebase'
import VueQrcode from 'vue-qrcode';
import LessonInfo from '../shared/LessonInfo';
export default {
    name: "ILessonStats",

    data() {
        return {
            lesson: null,
            topic:{
              'name':null,
              'description':null,
              'price':0,
              'tags':[],
              'shortname':null
            },
            content:{
              'name':null,
              'description':null,
              'videoUrl':null,
              'published':false,
              'startDay':null,
              'endDay':null,
              'code':null,
              'duration':null,
              'shortname':null
            },
            topics:[],
            types:[],
            selectedType:null,
            studentsText:'',
            selectedTopic:null,
            tmpStudents:[],
                        
            display:0,
            tagText:null,
            dayStr:null,
            selectedCell:null,
            selectedTopicIndex:null,
            selectedGroupIndex:null,
            schools:[],
            teachers:[],
            school:null,
            teacher:null,
            groups:[]

            
        };
    },
    methods: {
        
      async _getQA(){


          var doc=await fb.db.collection("schools/"+this.schoolId+"/lessons").doc(this.lessonId).get();
          let lesson=doc.data();
          lesson.id=doc.id;
          this.lesson=lesson;
          this.groups=[];
          // for(const group of this.lesson.groups){
          //   var y = Object.assign({}, group); 
          //   y.students=[];
          //   y.count=0;
          //   this.groups.push(y);

          // }

          if(this.lesson.isGroup!=null && this.lesson.isGroup!=undefined && this.lesson.isGroup==true){
              for(const group of this.lesson.lessonGroups){
                  var y = Object.assign({}, group); 
                  y.students=[];
                  y.count=0;
                  y.isGroup=true;
                  this.groups.push(y);
                
              }
          }

          else{
              for(const group of this.lesson.groups){
                var y = Object.assign({}, group); 
                y.students=[];
                y.count=0;
                this.groups.push(y);

              }
            
          }
          await this.getTopics();
          this.getStudents();
            

      },
      async getStudents(){
        if(this.lesson!=null && this.lesson!=undefined && this.lesson.groups && this.lesson.groups.length>0){
          for(const group of this.groups){
            
            var studentsSnapshot;
            if(group.isGroup && group.isGroup==true){
              studentsSnapshot=await fb.db.collection("schools/"+this.schoolId+"/students").where("lessonGroups", "array-contains", group.group).get();
            }
            else
              studentsSnapshot=await fb.db.collection("schools/"+this.schoolId+"/students").where("program", "==", group.program).get();
            if(studentsSnapshot && !studentsSnapshot.empty){
              group.students=[];
              group.count=studentsSnapshot.size;
              for(const doc of studentsSnapshot.docs){
                let object=doc.data();
                object.id = doc.id;
                object.ref=doc.ref;
                object.topics=[];
                // console.log(object);
                for(const topic of this.topics){
                  
                  var y = Object.assign({}, topic);
                  y.data=null;
                  y.procent=0;
                  if(object && object.user){
                    fb.db.collection("schools/"+this.schoolId+"/lessons").doc(this.lesson.id).collection("topics").doc(topic.id).collection('susers').doc(object.user.id).onSnapshot(sdoc=>{
                      if(sdoc.exists){
                        y.data=sdoc.data();
                        if(y && y.data && y.data.numberOfUnderstand && y.data.numberOfTotalStatus){
                          y.procent=(y.data.numberOfUnderstand*100/y.data.numberOfTotalStatus).toFixed(2)
                        }
                      }
                    });
                    // console.log(
                    //   fb.db.collection("schools/"+this.schoolId+"/lessons").doc(this.lesson.id).collection("topics").doc(topic.id).path
                    // )
                  }
                  object.topics.push(y); 
                }
                
                
                group.students.push(object);
              }
        
          }
          }
          
        }
      },


      async getTopics(){
        if(this.lesson!=null && this.lesson!=undefined && this.lesson.groups && this.lesson.groups.length>0){
          var topicSnapshot=await fb.db.collection("schools/"+this.schoolId+"/lessons").doc(this.lesson.id).collection("topics").orderBy("createdAt","asc").get();
          if(topicSnapshot && !topicSnapshot.empty){
            this.topics=[];
            for(const doc of topicSnapshot.docs){
              let object=doc.data();
              object.id = doc.id;
              object.groups=[];
              object.procent=0;
              if(object && object.numberOfUnderstand && object.numberOfTotalStatus){
                object.procent=(object.numberOfUnderstand*100/object.numberOfTotalStatus).toFixed(2)
              }
              
              this.topics.push(object);
            }
      
          }
          
        }
      },

 
      _addTopic(gdata, i, j){
        this.dayStr=null;
        this.selectedTopicIndex=i;
        this.selectedGroupIndex=j;
        this.selectedCell=gdata;
        $('#exampleModal').modal('toggle');
      },
      _chooseTeacher(gdata, i, j){
        this.teacher=null;
        this.selectedTopicIndex=i;
        this.selectedGroupIndex=j;
        this.selectedCell=gdata;
        $('#teacherModal').modal('toggle');
      },
      
 
      setProperty(propertyName, object, value){
        if(object!=null && propertyName!=null){
          var tmp={};
          tmp[propertyName]=value;
          object.update(tmp);
        }
      },
    
      setPublished(value, lesson){

      },
      setPropContent(value,topic, item, propertyName){
        if(this.lesson!=null && topic!=null && item!=null && propertyName!=null)
          this.setProperty(propertyName, fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lesson.id+"/topics/"+topic.id+"/details/"+item.id), value);
      },

        _addProgram(){
          if(this.selectedCell && this.dayStr && this.dayStr!=''){
            if(this.selectedCell.exists){
              this.selectedCell.ref.update({
                "date": new Date(this.dayStr)
              });
            }
            else
              this.selectedCell.ref.set({
                "date": new Date(this.dayStr)
              });
            this.selectedCell.date=fb.firestore.Timestamp.fromDate(new Date(this.dayStr));
            
            // if(this.selectedTopicIndex && this.selectedGroupIndex){
            //   this.topics[this.selectedTopicIndex]['groups'][this.selectedGroupIndex].data().date=fb.firestore.Timestamp.now();
            // }
          }
          else{
            alert("Та мэдээллээ бүрэн оруулна уу.");
          }
        },
        _addTeacher(){
          console.log(this.selectedCell);
          console.log(this.teacher);
          if(this.selectedCell && this.teacher){
            var tmp= Object.assign({}, this.teacher);
        
              this.selectedCell.ref.update({
                "teacher": tmp
              });
            this.selectedCell.teacher=tmp;
            this._addTeacherToLesson(tmp);
            // if(this.selectedTopicIndex && this.selectedGroupIndex){
            //   this.topics[this.selectedTopicIndex]['groups'][this.selectedGroupIndex].data().date=fb.firestore.Timestamp.now();
            // }
          }
          else{
            alert("Та мэдээллээ бүрэн оруулна уу.");
          }
        },
        _addTeacherToLesson(teacher){
          var exists=false;
          if(this.lesson && this.lesson.teachers && this.lesson.teachers.length>0){
            for(const t of this.lesson.teachers){
              if(t.reference.id==teacher.reference.id){
                exists=true
                break;
              }
            }
          }
          if(exists==false){
            fb.db.collection("schools/"+this.schoolId+"/lessons").doc(this.lessonId).update({
              "teachers": fb.firestore.FieldValue.arrayUnion(teacher)
            });
          }
        },
        findStudents(sc, dep, pro){
          fb.db.collection("schools/"+this.schoolId+"/students").where("school", "==", sc).where("department", "==", dep).where("program", "==", pro).get().then(docs=>{
            for(const studentData of docs.docs){
              
              if(studentData!=null && studentData.exists){
                var studentDetail=studentData.data();
                this.addStudentToLesson(fb.db.collection("schools/"+this.schoolId+"/lessons").doc(this.lesson.id), studentData, studentDetail);
              }
            }
          });
        },
        _getSchools(){
          fb.db.collection("schools").doc(this.schoolId)
          .get()
          .then(schoolData=> {

            let school = schoolData.data();
            school.id=schoolData.id;
            school.ref=schoolData.ref;
            this.schools.push(school);
          })
          .catch(function(error) {
              console.log("Error getting documents: ", error);
          });
        },
        async readSchool(){
          this._getSchools();
            // if(this.userProfile!=null && this.userProfile['role']!=null && this.userProfile['role']=="admin"){
            //   this._getSchools();
            // }
            // else if(this.userProfile!=null && this.userProfile['role']!=null && this.userProfile['customer']!=null && (this.userProfile['role']=="sts" || this.userProfile['role']=="manager")){
            //    var cusDoc=await this.userProfile['customer'].get();
            //     if(cusDoc.exists && cusDoc.data().schools!=null && cusDoc.data().schools!=undefined && cusDoc.data().schools.length>0){
            //       for(const scRef of cusDoc.data().schools){
            //         scRef.get().then(schoolData=>{
            //           let school = schoolData.data();
            //           school.id=schoolData.id;
            //           school.ref=schoolData.ref;
            //           this.schools.push(school);
                    
            //         });
            //       }
            //     }
            // }
          
            // else if(this.userProfile!=null && this.userProfile['role']!=null && this.userProfile['customer']!=null && this.userProfile['role']=="teacher"){
            //     var cusDoc=await this.userProfile['customer'].get();
            //     if(cusDoc.exists && cusDoc.data().school!=null && cusDoc.data().school!=undefined){

            //         cusDoc.data().school.get().then(schoolData=>{
            //           let school = schoolData.data();
            //           school.id=schoolData.id;
            //           school.ref=schoolData.ref;
            //           this.schools.push(school);
         
            //         });
                  
            //     }
            // }

        },
        schoolChanged(){
          this.teacher=null;
          this.teachers=[];
          fb.db.collection("schools/"+this.schoolId+"/teachers").where("school", '==', this.school.ref).get().then(docs=>{
            docs.docs.forEach(value=>{
              let teacher={};
              teacher.id=value.id;
              teacher.code=value.data().code;
              teacher.reference=value.ref;
              teacher.firstName=value.data().name;
              teacher.lastName=value.data().lastname;
              teacher.description=value.data().description;
              this.teachers.push(teacher);
            });
          });
        },
    },
    computed: {
        ...mapState(['userProfile', 'currentUser'])
    },
    components: {
      VueQrcode,
      LessonInfo
    },
    props: {
      schoolId:{
        required:true
      },
      lessonId: { 
          required: true,
      }
    },
    created() {
        var _this=this;
        if(this.lessonId!=null && this.lessonId!=''){
          this._getQA();
          this.readSchool();
        }
            
    },
    filters: {
		  formatDate(val) {
          if (!val) { return '-' }
          let date = val.toDate()
          return moment(date).format('MM/DD/YYYY HH:mm');
      },
    }
  
};
</script>

